export default __webpack_public_path__ + "static/media/checkPilotBeer.3b73fd43.png";